import React from "react";
import { Button, Card, Icon } from "../ui";
import "../../styles/content.css";

/** โครง wizard หลายขั้น: stepper ซ้าย (desktop) / แถบความคืบหน้า (mobile) + ปุ่ม ย้อนกลับ/ถัดไป */
export default function Wizard({ steps, step, setStep, children, actions, title }) {
  const last = step === steps.length - 1;
  return (
    <div className="wiz">
      <aside className="wiz__steps" aria-label="ขั้นตอน">
        <Card>
          {title ? <div className="strong mb-8">{title}</div> : null}
          <div className="stepper">
            {steps.map((s, i) => (
              <button type="button" key={s.key} className={`step${i === step ? " is-active" : ""}${i < step ? " is-done" : ""}`} onClick={() => setStep(i)} aria-current={i === step ? "step" : undefined}>
                <span className="step__n">{i < step ? <Icon name="check" size={14} /> : i + 1}</span>{s.title}
              </button>
            ))}
          </div>
        </Card>
      </aside>
      <div>
        <div className="wiz__mobile mb-16">
          <div className="row-between"><b>{steps[step].title}</b><span className="faint" style={{ fontSize: 13 }}>ขั้น {step + 1}/{steps.length}</span></div>
          <div className="progress mt-8" role="progressbar" aria-valuemin={1} aria-valuemax={steps.length} aria-valuenow={step + 1}><i style={{ width: `${((step + 1) / steps.length) * 100}%` }} /></div>
        </div>
        <Card>
          <h2 className="hide-mobile mb-16">{steps[step].title}</h2>
          {children}
        </Card>
        <div className="wiz__foot">
          <Button onClick={() => setStep(step - 1)} disabled={step === 0}>ย้อนกลับ</Button>
          <div className="row wrap" style={{ justifyContent: "flex-end" }}>
            {actions}
            {!last ? <Button variant="primary" onClick={() => setStep(step + 1)}>ถัดไป</Button> : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export const Counted = ({ value, max }) => <div className={`counter${String(value || "").length > max ? " is-over" : ""}`}>{String(value || "").length}/{max}</div>;

export const Soon = ({ icon = "🔒", title, children }) => (
  <div className="soon" role="note">
    <span style={{ fontSize: 22 }} aria-hidden="true">{icon}</span>
    <div><div className="strong" style={{ color: "var(--text)" }}>{title} <span className="pill">ยังไม่เปิดให้บริการ</span></div>{children ? <div style={{ fontSize: 13 }}>{children}</div> : null}</div>
  </div>
);
